import { Component, Mixins } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';
import DetailLayout from '@/components/DetailLayout.vue';
import FileUpload from '@/components/FileUpload.vue';
import DraggableTable from '@/components/DraggableTable.vue';
import DraggableList from '@/components/DraggableList.vue';
import SpeedList from '@/components/SpeedList.vue';
import CustomField from '@/components/CustomField.vue';
import NewCustomField from '@/components/NewCustomField.vue';

@Component({
  components: {
    DetailLayout,
    FileUpload,
    DraggableTable,
    DraggableList,
    SpeedList,
    CustomField,
    NewCustomField
  }
})
export default class DetailMixin extends Mixins(CommonMixin) {}
